import { combineReducers } from 'redux'
import { routerReducer as routing } from 'react-router-redux'
import appContext from './appContext'
import client from './client'
import csrf from './csrf'
import formDialog from './formDialog'
import group from './group'
import loading from './loading'
import navigation from './navigation'
import notifications from './notifications'
import changePasswordFormDialog from './changePasswordFormDialog'
import permission from './permission'
import refresh from './refresh'
import { reducer as form } from 'redux-form'
import registration from './registration'
import forgotPassword from './forgotPassword'
import forgotPasswordResetForm from './forgotPasswordResetForm'
import role from './role'
import securityQuestionsFormDialog from './securityQuestionsFormDialog'
import table from './table'
import tableDialog from './tableDialog'
import user from './user'
import authProfile from './authProfile'

export default combineReducers({
  appContext,
  client,
  csrf,
  // you have to pass formReducer under 'form' key,
  // for custom keys look up the docs for 'getFormState'
  form,
  formDialog,
  group,
  loading,
  navigation,
  notifications,
  changePasswordFormDialog,
  permission,
  refresh,
  registration,
  forgotPassword,
  forgotPasswordResetForm,
  role,
  routing,
  securityQuestionsFormDialog,
  table,
  tableDialog,
  user,
  authProfile
})
